import React, { Component } from 'react';

import CreatePanel from './components/CreatePanel';
import UserList from './components/UserList';
import CreatePanelTest from './components/CreatePanelTest';
import TestList from './components/TestList';

var AdminPanel = React.createClass({
  render: function(){
    return(
      <div className="AdminPanel">
        <div className="CreatePanel">
          <div onClick={this.props.exit} className="SelectSpecialtiesOpen">Выйти</div>
        </div>
        <CreatePanel
          actionReloadUsers={this.props.actionReloadUsers}
          login={this.props.login}
          pass={this.props.pass}
          specialties={this.props.specialties}
        />
        <CreatePanelTest
          specialties={this.props.specialties}
          login={this.props.login}
          pass={this.props.pass}
          handlerReloadSpecialties={this.props.handlerReloadSpecialties}
        />

        <div className="headlineWrapper">
          <div className="headline">Пользователи</div>
          
        </div>
        
        <UserList
          users={this.props.users}
          actionReloadUsers={this.props.actionReloadUsers}
          login={this.props.login}
          pass={this.props.pass}
          specialties={this.props.specialties}
        />
        <div className="headlineWrapper">
          <div className="headline">Тесты</div>
          
        </div>
        <TestList
          handlerReloadSpecialties={this.props.handlerReloadSpecialties}
          login={this.props.login}
          pass={this.props.pass}
          specialties={this.props.specialties}
        />
      </div>
    );
  }
});

export default AdminPanel;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/index.jsx
 **/